export const schema = {
    title: 'App Version',
    type: 'object',
    required: ['platform', 'version'],
    properties: {
        id: { type: 'integer' },
        platform: {
            type: 'string',
            title: 'Platform',
            enum: ['ios', 'android', 'pad-ios', 'pad-android'],
            enumNames: ['iOS', 'Android', 'Pad iOS', 'Pad Android']
        },
        version: {
            type: 'string',
            title: 'Version Number',
        },
        force_update_required: {
            type: 'boolean',
            title: 'Force Update Required',
            default: false,
        },
        title: {
            type: 'string',
            title: 'Title',
            default: 'Update Available',
            maxLength: 100
        },
        message: {
            type: 'string',
            title: 'Message',
            maxLength: 255
        },
    },
};

/**
 * @name getSchema
 * @description Returns the schema for App Versioning. 
 */
export const getSchema = (props) => {
    const schemaCopy = JSON.parse(JSON.stringify(schema));
    return schemaCopy;
};

export default getSchema;